module.exports = __webpack_public_path__ + "img/blue-circle-middle_yellow-circle-small.a12a0dab.svg";